import { useQuery, UseQueryOptions } from 'react-query';

import { GET_BRANCHES, GetBranchesQueryData, GetBranchesQueryKey } from '../queries/get-branches.query';

export const useGetBranchesQuery = (options?: UseQueryOptions<GetBranchesQueryData, Error, GetBranchesQueryData, GetBranchesQueryKey>) => {
  return useQuery<GetBranchesQueryData, Error, GetBranchesQueryData, GetBranchesQueryKey>(['branches'], GET_BRANCHES, options);
};
